"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ActionsRedesignOpt = _interopRequireDefault(require("crm_ui/profile/experiments/ActionsRedesignOpt"));

var _generalStore = require("general-store");

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _OptInsDependency = require("crm_data/optIns/OptInsDependency");

var _react = _interopRequireWildcard(require("react"));

var dependencies = {
  isOptedInToActionsRedesign: (0, _OptInsDependency.isOptedInDependency)('record-actions-redesign'),
  isUngatedForActionsRedesign: {
    stores: [_IsUngatedStore.default],
    deref: function deref() {
      return _IsUngatedStore.default.get('CRM:RecordActions');
    }
  }
};

var ActionsRedesignOptConnector =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ActionsRedesignOptConnector, _Component);

  function ActionsRedesignOptConnector() {
    (0, _classCallCheck2.default)(this, ActionsRedesignOptConnector);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActionsRedesignOptConnector).apply(this, arguments));
  }

  (0, _createClass2.default)(ActionsRedesignOptConnector, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_ActionsRedesignOpt.default, this.props);
    }
  }]);
  return ActionsRedesignOptConnector;
}(_react.Component);

var _default = (0, _generalStore.connect)(dependencies)(ActionsRedesignOptConnector);

exports.default = _default;
module.exports = exports.default;